// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../phoenix-app/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container--1meRy{position:absolute;height:100%;width:100%;top:0;left:0;z-index:-1;background-position:center;background-size:contain;background-repeat:no-repeat}", ""]);
// Exports
exports.locals = {
	"container": "container--1meRy"
};
module.exports = exports;
